import { useMutation } from '@tanstack/react-query';
import { submitBankAddressStep } from '../requests';
import type {
  BankAddressStepRequest,
  BankAddressStepResponse,
} from '../../model';

export function useSubmitBankAddressStep() {
  const mutation = useMutation<
    BankAddressStepResponse,
    Error,
    BankAddressStepRequest
  >({
    mutationFn: submitBankAddressStep,
    retry: 0,
  });

  return {
    data: mutation.data,
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
